import React, { Component } from "react";
import { Link } from "react-router-dom";
import ChatContainer from './ChatContainer';
import { subscribeNewsletter } from '../../api/email';

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newsletterEmail: '',
            newsletterSubmitting: false,
            newsletterSuccess: false,
            newsletterError: null
        };
    }

    handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        
        // Clear any previous errors or success messages
        this.setState({ 
            newsletterSubmitting: true, 
            newsletterError: null,
            newsletterSuccess: false
        });

        const result = await subscribeNewsletter(this.state.newsletterEmail);
        
        if (result.success) {
            this.setState({ 
                newsletterSuccess: true, 
                newsletterEmail: '',
                newsletterSubmitting: false
            });
            
            // Clear success message after 5 seconds
            setTimeout(() => {
                this.setState({ newsletterSuccess: false });
            }, 5000);
        } else {
            this.setState({ 
                newsletterError: result.error,
                newsletterSubmitting: false
            });
            
            // Clear error message after 5 seconds
            setTimeout(() => {
                this.setState({ newsletterError: null });
            }, 5000);
        }
    };

    render() {
        return (
            <>
                {/* start footer */}
                <footer className="footer section bg-cover overlay-dark pt-60" style={{backgroundImage: "url(assets/images/bg-footer2.jpg)"}}>
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-xl-3 col-md-6 mt-40">
                                <img className="mb-25" src={process.env.PUBLIC_URL + '/assets/images/logo-light.png'} alt="" />
                                <p className="text-gray">
                                Expert device repair by our technicians that have been fixing devices for happy customers for over 10 years.
                                </p>
                                <ul className="social-links list-unstyled mt-25">
                                    <li><Link to={'https://www.facebook.com/iscreenfixmb/'} className="initiate-scripts"><span className="fab fa-facebook-f" /></Link></li>
                                    <li><Link to={'https://twitter.com/iscreenfix'} className="initiate-scripts"><span className="fab fa-twitter" /></Link></li>
                                    {/*<li><Link to={'https://www.instagram.com/iscreenfix_myrtlebeach/?hl=en'} className="initiate-scripts"><span className="fab fa-instagram" /></Link></li>*/}
                                </ul>
                            </div>
                            <div className="col-xl-3 col-md-6 mt-40">
                                <h4 className="font-w-600 text-white mb-10">Quick Links</h4>
                                <ul className="footer-links list-unstyled text-uppercase">
                                    <li><Link to={'/services'} className="initiate-scripts">All Services</Link></li>
                                    <li><Link to={'/mobile-repair'} className="initiate-scripts">Phones</Link></li>
                                    <li><Link to={'/monitoring'} className="initiate-scripts">Monitoring</Link></li>
                                    <li><Link to={'/game-repair'} className="initiate-scripts">Game Consoles</Link></li>
                                    <li><Link to={'/pc-laptop-repair'} className="initiate-scripts">Computers</Link></li>
                                </ul>
                            </div>
                            <div className="col-xl-3 col-md-6 mt-40">
                                <h4 className="font-w-600 text-white mb-10">Quick Links</h4>
                                <ul className="footer-links list-unstyled text-uppercase">
                                    <li><Link to={'/team'} className="initiate-scripts">About Us</Link></li>
                                    <li><Link to={'/blog'} className="initiate-scripts">Blog</Link></li>
                                    <li><Link to={'/contact'} className="initiate-scripts">Contact Us</Link></li>
                                    <li><Link to="/login" className="initiate-scripts">Sign in</Link></li>
                                    <li><Link to={'/login'} className="initiate-scripts">My account</Link></li>
                                </ul>
                            </div>
                            <div className="col-xl-3 col-md-6 mt-40">
                                <h4 className="font-w-600 text-white mb-10">Get in touch</h4>
                                <div className="text-gray mt-20">
                                    <span className="icon text-primary fas fa-phone-alt mr-2" />
                                    1 (843) 900 4668
                                </div>
                                <div className="text-gray mt-20">
                                    <span className="icon text-primary fas fa-envelope mr-2" />
                                    info@iscreenfix.com
                                </div>
                                <div className="text-gray mt-20">
                                    <span className="icon text-primary fas fa-home mr-2" />
                                    981 Hackler St, Myrtle Beach, SC
                                </div>
                                <div className="text-white mt-20 mb-10">
                                    Subscribe to our newsletter for updates and special offers
                                </div>
                                <form className="mt-25" onSubmit={this.handleNewsletterSubmit}>
                                    <div className="input-group input-group-primary">
                                        <input 
                                            type="email" 
                                            className="form-control text-white px-3 bg-transparent shadow-none border-0" 
                                            placeholder="Email address"
                                            value={this.state.newsletterEmail}
                                            onChange={(e) => this.setState({ newsletterEmail: e.target.value })}
                                            required
                                        />
                                        <div className="input-group-apend">
                                            <button 
                                                className="btn btn-isf rounded-circle" 
                                                type="submit"
                                                disabled={this.state.newsletterSubmitting}
                                            >
                                                <span className="fas fa-chevron-right" />
                                            </button>
                                        </div>
                                    </div>
                                    {this.state.newsletterSuccess && (
                                        <div className="text-success mt-2">
                                            Thank you for subscribing!
                                        </div>
                                    )}
                                    {this.state.newsletterError && (
                                        <div className="text-danger mt-2">
                                            {this.state.newsletterError}
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </footer>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <p>Copyright © 2025. All Rights Reserved By iScreenFix</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* end footer */}

                <ChatContainer />

                <a href="#top" className="scroll-to-top">
                    <span className="fas fa-chevron-up" />
                </a>
                {/* scroll to top */}
            </>
        );
    }
}

export default Footer;